// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__a5vkT","modal":"styles_modal__hlznT","message":"styles_message__eUsyA","buttons":"styles_buttons__6+hk6","solo":"styles_solo__n8kly"};